import CertificateSelector from 'components/certUploader/CertificateSelector';
import React from 'react';
import { ConfigurationElement } from '../../../types/rest/configurationsType';
import _ from 'lodash';

interface ConfigurableAssetProps {
  configElement: ConfigurationElement;
  onChange: (config: ConfigurationElement) => void;
}
const ConfigurableAsset = (props: ConfigurableAssetProps) => {
  const { configElement, onChange } = props;
  const onSelectCertHandler = (certId: number) => {
    //Make sure alias field cleared when cert is selected
    onChange({ ...configElement, assetId: certId, alias: null } as ConfigurationElement);
  };

  const onSelectAliasHandler = (alias: string) => {
    onChange({ ...configElement, alias: alias });
  };
  return (
    <div>
      <CertificateSelector
        selectedCertificateId={props.configElement.assetId}
        type={'ALL'}
        variant={'inline'}
        onRemoveCertificate={_.noop}
        onSelectAlias={(id, alias) => onSelectAliasHandler(alias)}
        onSelectCertificate={certId => onSelectCertHandler(certId)}
      />
    </div>
  );
};

export default ConfigurableAsset;
